import React, { useMemo, useState } from 'react';
import PageBanner from '@/components/site/PageBanner';
import ToolNav from '@/components/site/ToolNav';
import SEO from '@/components/site/SEO';
import Reveal from '@/components/site/Reveal';

const EligibilityCalculator = () => {
  const [income, setIncome] = useState(75000);
  const [obligations, setObligations] = useState(10000);
  const [rate, setRate] = useState(10.5);
  const [tenure, setTenure] = useState(20);

  const eligible = useMemo(() => {
    const net = Math.max(0, Number(income) - Number(obligations));
    const emiCapacity = net * 0.55;
    const r = Number(rate) / 12 / 100;
    const n = Number(tenure) * 12;
    if (r <= 0 || n <= 0) return 0;
    return (emiCapacity * (Math.pow(1 + r, n) - 1)) / (r * Math.pow(1 + r, n));
  }, [income, obligations, rate, tenure]);

  return (
    <main>
      <SEO
        title="Home Loan Eligibility Calculator | Check Loan Eligibility | Finirio"
        description="Check your home loan eligibility online with Finirio. Enter your income, obligations and tenure to know the maximum loan amount you qualify for."
        path="/eligibility-calculator"
        keywords="home loan eligibility, loan eligibility calculator india, home loan calculator"
      />
      <PageBanner title="Eligibility Calculator" crumbs={[ 'Calci and Docs', 'Eligibility Calculator' ]} />
      <ToolNav />
      <section className="py-16 bg-white">
        <div className="max-w-[900px] mx-auto px-4 lg:px-6">
          <Reveal>
            <div className="card-lux p-6 md:p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {[
                  { label: 'Monthly Net Income (₹)', v: income, s: setIncome },
                  { label: 'Existing EMIs / Obligations (₹)', v: obligations, s: setObligations },
                  { label: 'Interest Rate (%)', v: rate, s: setRate, step: 0.1 },
                  { label: 'Loan Tenure (Years)', v: tenure, s: setTenure },
                ].map((f, i) => (
                  <div key={i}>
                    <label className="block text-[#0b2545] text-sm font-semibold mb-2">{f.label}</label>
                    <input
                      type="number"
                      step={f.step || 1}
                      value={f.v}
                      onChange={(e) => f.s(e.target.value)}
                      className="w-full h-11 px-3.5 border border-slate-200 rounded-lg outline-none transition focus:border-[#1e73be] focus:ring-2 focus:ring-[#1e73be]/20"
                    />
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={120}>
            <div className="mt-8 rounded-2xl p-8 text-center navy-panel relative overflow-hidden">
              <div className="hairline-gold absolute top-0 left-0 right-0" />
              <p className="text-white/70 text-sm">You are eligible for a loan up to</p>
              <p className="font-heading text-gold-grad text-[36px] md:text-[42px] font-bold mt-2">
                &#8377; {Math.round(eligible).toLocaleString('en-IN')}
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default EligibilityCalculator;
